/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Inject, Input, OnInit, inject} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import template from './political-entity-list-page.component.html';

import {AppSharedModule} from '../common/app-shared.module';
import {SignalAdminResourceListComponent} from '../common/controller/signal-admin-resource-list.component';
import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../common/controller/signal-admin-resource-list-state';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';
import {PoliticalEntityApiService, PoliticalEntityModel} from './political-entity-api.service';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule, SignalAdminResourceListComponent],
  selector: 'adn-political-entity-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PoliticalEntityListPageComponent implements OnInit {
  readonly itemStateName = 'app.pol.political-entities.political-entity';

  showVisibilityType = false;
  columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'type'},
    {param: 'ownerTeam', labelInstant: 'Owner team', sortable: false},
    {param: 'legalEntity', labelInstant: 'Legal Entity', sortable: false},
    {param: 'contactEmail', labelInstant: 'Contact Email'},
    {param: 'siteUrl', labelInstant: 'URL'}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<PoliticalEntityModel>(
    inject(PoliticalEntityApiService),
    {listId: 'fullPoliticalEntityList', searchFields: 'name;description;contactEmail;siteUrl'},
    inject(DestroyRef)
  );

  constructor(@Inject(LocalUserPermissions) private readonly LocalUserPermissions: any) {}

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.showVisibilityType = this.LocalUserPermissions.hasNetworkPermission('MANAGE_SYSTEM');
    if (this.showVisibilityType) {
      this.columns = [
        ...this.columns.slice(0, 2),
        {param: 'visibilityType', labelInstant: 'Visibility Type'},
        ...this.columns.slice(2)
      ];
    }
    this.list.load();
  }

  ownerTeamLabel(entity: any): string {
    return (entity.ownerTeam && entity.ownerTeam.name) || entity.ownerTeam || '';
  }

  legalEntityLabel(entity: any): string {
    return entity.legalEntity || '';
  }
}
